// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__Aq3Ff","mainContent":"LoginPage_mainContent__ICCes"};